module.exports = __webpack_public_path__ + "img/717b9de.jpg";